import React, { useEffect, useRef } from 'react';
import UsersTable from '../components/UsersTable';
import { toast } from 'react-toastify';

const AllUsers = ({ users, setUsers }) => {
  // Kullanıcı sayısını ilk yüklemede kaydet
  const initialUsersCount = useRef(users.length);

  useEffect(() => {
    // users dizisindeki sayı değiştiyse (yeni kullanıcı eklenmiş)
    if (users.length !== initialUsersCount.current) {
      // Önceki count'u güncelle
      initialUsersCount.current = users.length;
      // Bildirimi göster
      toast.info('A new user has been added!', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    }
  }, [users]);

  return (
    <div>
      <h1 className="title-page">All Users</h1>
      <UsersTable users={users} setUsers={setUsers} />
    </div>
  );
};

export default AllUsers;